import React from "react";
import GlobalStyle from "../styles/global";
import { Switch, Route } from "react-router-dom";
import Header from "../components/Header/withData";
import Home from "./Home/withData";
import Biography from "./Biography/withData";
import Galleries from "./Galleries/withData";
import News from "./News/withData";
import Works from "./Works/withData";
import Writings from "./Writings/withData";
import Downloads from "./Downloads/withData";
import Contact from "./Contact/withData";

class Root extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div>
        <GlobalStyle />
        <Header />
        <div>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/biography" exact component={Biography} />
            <Route path="/contact" exact component={Contact} />
            <Route path="/downloads" exact component={Downloads} />
            <Route path="/works/:slug" component={Works} />
            <Route path="/writings/:slug?" component={Writings} />
            <Route path="/galleries" exact component={Galleries} />
            <Route path="/news" exact component={News} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Root;
